"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.barLabel = exports.axis = exports.axisLabel = exports.cardButton = exports.cardDescription = exports.cardTitle = exports.cardBorderShadow = exports.cardOverflow = exports.cardBorder = exports.card = exports.cardContainerWide = exports.cardContainer = exports.varCorrelationTableCellHeight = exports.chartAxisSize = exports.chartFontSize = void 0;
var typestyle_1 = require("typestyle");
var colors = require("../util/colors");
var sizes = require("../util/sizes");
require("@tableau/fonts-tableau");
// SIZE CONSTANTS
exports.chartFontSize = '9px';
exports.chartAxisSize = '1px';
exports.varCorrelationTableCellHeight = '16px';
// CARD
exports.cardContainer = typestyle_1.style({
    width: sizes.cardWidthRegular.toString() + 'px',
    margin: '0.5em',
});
exports.cardContainerWide = typestyle_1.style({
    width: sizes.cardWidthWide.toString() + 'px',
    margin: '0.5em',
});
exports.card = typestyle_1.style({
    padding: '1.5em',
    display: 'flex',
    flexDirection: 'column',
});
exports.cardBorder = typestyle_1.style({
    border: 'solid #b3b3b3 thin',
});
exports.cardOverflow = typestyle_1.style({
    maxHeight: 300,
    overflowY: 'auto',
});
exports.cardBorderShadow = typestyle_1.style({
//border: 'solid #b3b3b3 thin',
//boxShadow: 'rgb(0 0 0 / 15%) 1.95px 1.95px 2.6px', // TODO: style box shadow closer to UX
});
exports.cardTitle = typestyle_1.style({
    marginBottom: '0.5em',
    fontWeight: 'bold',
    textAlign: 'center',
});
exports.cardDescription = typestyle_1.style({
    fontSize: '12px',
    marginBottom: '1.25em',
    color: colors.tableauGray11,
});
exports.cardButton = typestyle_1.style({
    color: '#46a0dc',
    border: 'solid #b3b3b3 thin',
    width: '100%',
    height: '3em',
    cursor: 'pointer',
});
// D3 CHARTS
// Dimension headers
exports.axisLabel = typestyle_1.style({
    color: colors.tableauGray11,
    fontSize: exports.chartFontSize,
    fontFamily: 'Tableau',
    textAnchor: 'middle',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '11px',
});
exports.axis = typestyle_1.style({
    color: colors.tableauGray11,
    fontFamily: 'Tableau',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '11px',
    fontSize: exports.chartFontSize,
    strokeWidth: 0,
});
exports.barLabel = typestyle_1.style({
    fontSize: '10px',
});
//# sourceMappingURL=PredictionModelResultsViz.js.map